import * as React from "react";


function SustainabilityList({setIndex}) {
  const listItems = [
    {
      text: "SUSTAINABILITY",
      className:
        " max-md:max-w-full",
    },
    { text: "ESG", className: "mt-6 max-md:max-w-full" },
    { text: "INTEGRATED APPROACH", className: "mt-7 max-md:max-w-full" },
    { text: "CLIMATE AND ESG", className: "mt-6 font-extrabold tracking-wider uppercase leading-[115%] max-md:max-w-full" },
  ];

  return (
    <div className="flex flex-col text-sm text-white grow shrink-0 basis-0 w-fit max-md:max-w-full">
      {listItems.map((item, index) => (
        <div style={{cursor:'pointer'}}  onClick={()=>setIndex(index)} key={index} className={item.className}>
          {item.text}
        </div>
      ))}
     
    </div>
  );
}

function VerticalDivider() {
  return (
    <div className="flex flex-col self-start">
      <img
        src="https://cdn.builder.io/api/v1/image/assets/TEMP/865684885fe70e8157bc1a8b2c82c2af261fda4f25128ded5e753fc60d3591a7?apiKey=4bc115756c014cc3a902e6c24f3eb476&"
        alt=""
        className="self-center border border-white border-solid aspect-[1.16] w-[7px]"
      />
      <div className="shrink-0 bg-white h-[15px]" />
      <div className="shrink-0 bg-white h-[15px]" />
      <div className="shrink-0 rounded-lg border border-white border-solid h-[7px]" />
      <div className="z-10 shrink-0 bg-white h-[15px]" />
      <div className="shrink-0 bg-white h-[15px]" />
      <div className="shrink-0 h-1.5 rounded-lg border border-white border-solid" />
      <div className="shrink-0 bg-white h-[15px]" />
      <div className="shrink-0 bg-white h-[15px]" />
      <div className="shrink-0 h1.5 rounded-lg border border-white border-solid" />
    </div>
  );
}

function ClimateLeft({setIndex}) {
  return (
    <div className="relative flex flex-col w-full h-full py-5 pl-20 pr-5 overflowhidden max-md:pl-5">
      <img
        src="/assets/images/climate.jpeg"
        alt=""
        className="absolute inset-0 object-cover size-full"
      />
    
      <h1 className="relative  mt-44 text-6xl font-black tracking-wider text-white uppercase leading-[60.16px] maxmd:mt-10 max-md:max-w-full max-md:text-4xl">
        Climate and ESG
      </h1>
      <div className="flex relative gap-4 mt-36 -ml-2.5 max-md:flex-wrap max-md:mt-10">
        {/* <VerticalDivider /> */}
        <SustainabilityList setIndex={setIndex}/>
      </div>
    </div>
  );
}

export default ClimateLeft;
